var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.cartBadgeCount > 0
    ? _c(
        "div",
        {
          staticClass:
            "position-absolute basketcounter-big d-flex justify-content-center align-items-center",
          class: "basketcounter--" + _vm.theme,
        },
        [_c("span", [_vm._v(_vm._s(_vm.cartBadgeCount))])]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }